import { Flex } from "antd";
import { FC } from "react";

import { logout } from "@/app/AuthProvider";

import BookIcon from "@/assets/book.svg?react";
import LogoutIcon from "@/assets/logout.svg?react";
import NewsIcon from "@/assets/news.svg?react";
import SettingsIcon from "@/assets/settings.svg?react";
import PieChartIcon from "@/assets/pie_chart.svg?react";

import { MenuItem, MenuItemProps } from "./MenuItem";

import "./index.less";

interface HeaderMenuProps {
  isVisible: boolean;
  setIsVisible: () => void;
}

const blocks: { [key: string]: MenuItemProps[] } = {
  navigation: [
    { icon: <PieChartIcon />, text: "Dashboard", to: "/explore/dashboard" },
    { icon: <BookIcon />, text: "My Learning", to: "/explore/my-learning" },
    { icon: <NewsIcon />, text: "Post Feed", to: "/explore/post-feed" },
  ],
  settings: [{ icon: <SettingsIcon />, text: "Profile", to: "/explore/user/account" }],
  dangerZone: [{ icon: <LogoutIcon />, text: "Log out", onClick: () => logout() }],
};

export const HeaderMenu: FC<HeaderMenuProps> = ({ isVisible }) => {
  return (
    <Flex className={`header-menu-container ${isVisible && "menu-visible"}`} vertical justify="space-between">
      <Flex vertical gap={24}>
        <Flex vertical gap={8}>
          {blocks.navigation.map((b) => (
            <MenuItem key={b?.text} {...b} />
          ))}
        </Flex>
        <Flex vertical gap={8}>
          {blocks.settings.map((b) => (
            <MenuItem key={b?.text} {...b} />
          ))}
        </Flex>
      </Flex>
      <Flex vertical gap={8}>
        {blocks.dangerZone.map((b) => (
          <MenuItem key={b?.text} {...b} />
        ))}
      </Flex>
    </Flex>
  );
};
